import * as moment from 'moment';

function dateToHumanFormat(date) {
  moment.locale('ru');
  return moment(date).format('D MMMM YYYY, HH:mm');
}

export default dateToHumanFormat;
